import { ContainerModule } from 'inversify';
import interactionStoreModule, { InteractionStoreModuleSymbol } from './interaction-state-store-module';
import { InteractionStateQuery, InteractionStateQuerySymbol } from './interaction-query'

export const interactionStoreContainerModule = new ContainerModule((bind) => {
  bind(InteractionStoreModuleSymbol).toConstantValue(interactionStoreModule)
  bind<InteractionStateQuery>(InteractionStateQuerySymbol)
    .toDynamicValue(c => c.container.get(InteractionStoreModuleSymbol))
});
